// ----------------------------------------------------------------------
// <copyright file="Izenda.DashboardRoot.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import React, { Component } from 'react';
import connect from 'share/enhancers/Izenda.Connect';
import Dashboard from './Izenda.Dashboard';
import DashboardStore from 'logic/Izenda.DashboardStore';
import { LICENSE_KEY } from 'logic/data/Izenda.LicenseCheckerConstants';
import routeUtils from 'share/utils/Izenda.RouteUtils';
import uiState from 'logic/Izenda.UiState';
import { get, isNil, uniqueId } from 'lodash/fp';

@connect({ licenseKey: LICENSE_KEY.Dashboard })
class DashboardContainer extends Component {
  constructor(props) {
    super(props);
    this.initState();
  }

  componentWillReceiveProps(nextProps) {
    const isLocationChanged =
      !get('location.state.keepState', nextProps) &&
      nextProps.location.key !== this.props.location.key;
    isLocationChanged && this.initState();
  }

  initState() {
    // License is expired, navigate to Settings pages
    if (uiState.expiredLicense) {
      const settingLink = routeUtils.getSettingsUrl();
      this.props.router.push(settingLink);
    }

    this.locationKey = uniqueId('DashboardLocationKey_');
    this.store = new DashboardStore();
  }

  componentWillUnmount() {
    this.store.destroy();
  }

  render() {
    const id = !isNil(this.props.params) ? this.props.params.id : null;
    const newDashboard = !!get(
      'needCreateNewDashboard',
      this.props.location.state
    );

    return (
      !uiState.expiredLicense && (
        <Dashboard
          key={this.locationKey}
          id={id}
          newDashboard={newDashboard}
          store={this.store}
          {...this.props}
        />
      )
    );
  }
}

export { Component as Dashboard, DashboardContainer as Container };



// WEBPACK FOOTER //
// ./ui/modules/Dashboard/Izenda.DashboardRoot.js